import React, { useContext, useState } from "react";
import { UserContext } from "../../../../context";
import { Separator, Switch, Text } from "../../../../components";
import {
  BillingStyle,
  MontlyYearlyStyle,
  MontlyYearlyStyleLeft,
  MontlyYearlyStyleRight,
  PricingButtonStyle,
  PricingCardStyle,
  PricingContainer,
  PricingFeatureIconStyle,
  PricingFeatureStyle,
  PricingFreeButtonStyle,
  SelectedTagStyle,
  TrialBannerStyle,
} from "../../styles";
import {
  CheckCircleIcon,
  InfiniteSpinnerIcon,
  PlainCheckCircleIcon,
} from "../../../../components/icons";
import { config } from "../../../../config";

type PaymentProps = {
  currentPlan: {
    isTrial: boolean;
    isFree: boolean;
  };
  pricing: {
    normalPrice: number;
    discountPrice: number;
  };
  vipUser?: boolean;
};
export const Payment: React.FC<PaymentProps> = ({
  currentPlan,
  pricing,
  vipUser,
}) => {
  const [quantity, setQuantity] = useState<number>(1);
  const [annually, setAnnually] = useState(false);
  const { state: userState } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [freeLoading, setFreeLoading] = useState(false);

  const { normalPrice, discountPrice } = pricing;

  const price = !annually ? normalPrice : discountPrice;

  //const handleQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //  setQuantity(parseInt(e.target.value));
  //};
  //
  const onSelected = (selected: boolean) => {
    setAnnually(selected);
    if (selected) {
      setQuantity(12);
    } else {
      setQuantity(1);
    }
  };

  const { isFree, isTrial } = currentPlan;
  

  return (
    <div className={BillingStyle}>
      <div className={MontlyYearlyStyle}>
        <div className={MontlyYearlyStyleLeft}>
          {" "}
          <Text.BodySM color="seconday">Monthly</Text.BodySM>
        </div>
        <Switch selected={annually} onSelected={onSelected} />
        <div className={MontlyYearlyStyleRight}>
          <Text.BodySM
            color="primary"
            marginBottom={0}
            marginTop={0}
            style={{ marginRight: "4px" }}
          >
            Yearly
          </Text.BodySM>
          <Text.Body3XS color="highlight/3" marginBottom={0} marginTop={0.3}>
            SAVE 4 MONTHS
          </Text.Body3XS>
        </div>
      </div>
      <div className={PricingContainer}>
        <div className={PricingCardStyle(isFree)}>
          {isFree && (
            <div className={SelectedTagStyle}>
              <PlainCheckCircleIcon />
            </div>
          )}
          <div>
            <Text.BodyXS color="seconday" marginTop={3}>
              Inbox management
            </Text.BodyXS>
            <Text.H2>$0/mo</Text.H2>
            <Separator.Horizontal spacing={4} />
            <div className={PricingFeatureStyle}>
              <CheckCircleIcon style={PricingFeatureIconStyle} fill="#8C83C3" />
              <Text.BodySM style={{ width: "90%" }}>
                AI inbox assistance – Prioritizes, labels, and archives (300
                emails/mo)
              </Text.BodySM>
            </div>
            <div className={PricingFeatureStyle}>
              <CheckCircleIcon style={PricingFeatureIconStyle} fill="#8C83C3" />
              <Text.BodySM style={{ width: "90%" }}>
                Weekly recap – Snapshot of your most important emails
              </Text.BodySM>
            </div>
          </div>

          <form
            action={`${config.apiUrl}/billing/customer-portal`}
            method="POST"
          >
            <input type="hidden" name="userId" value={userState?._id} />
            {!isTrial && (
              <button
                className={PricingFreeButtonStyle}
                disabled={isFree}
                type="submit"
                onClick={() => setFreeLoading(true)}
                style={{
                  cursor: freeLoading ? "progress" : "",
                  pointerEvents: freeLoading ? "none" : "auto",
                }}
              >
                {isFree ? "Current plan" : "Downgrade to Free"}
                {freeLoading ? (
                  <InfiniteSpinnerIcon
                    fill="primary"
                    style={{ height: "16px", marginLeft: "8px" }}
                  />
                ) : null}
              </button>
            )}
          </form>
        </div>
        <div className={PricingCardStyle(!isFree || isTrial)}>
          {!isFree && (
            <div className={SelectedTagStyle}>
              <PlainCheckCircleIcon />
            </div>
          )}
          {!isFree && isTrial && (
            <div className={TrialBannerStyle}>
              <Text.Body2XS color="dark">
                {vipUser ? "Exclusive access" : "Trial period"}
              </Text.Body2XS>
            </div>
          )}
          <div>
            <Text.BodyXS color="seconday" marginTop={3}>
              Executive assistant
            </Text.BodyXS>
            <Text.H2>${price}/mo</Text.H2>
            <Separator.Horizontal spacing={4} />
            <div className={PricingFeatureStyle}>
              <CheckCircleIcon style={PricingFeatureIconStyle} fill="#8C83C3" />
              <Text.BodySM style={{ width: "90%" }}>
                Unlimited inbox assistance – No email limits
              </Text.BodySM>
            </div>
            <div className={PricingFeatureStyle}>
              <CheckCircleIcon style={PricingFeatureIconStyle} fill="#8C83C3" />
              <Text.BodySM style={{ width: "90%" }}>
                Daily recap – Key email summaries, action items, and
                personalized briefing podcast
              </Text.BodySM>
            </div>
            <div className={PricingFeatureStyle}>
              <CheckCircleIcon style={PricingFeatureIconStyle} fill="#8C83C3" />
              <Text.BodySM style={{ width: "90%" }}>
                Meeting prep – Attendee insights, company details, and
                icebreakers
              </Text.BodySM>
            </div>
            <div className={PricingFeatureStyle}>
              <CheckCircleIcon style={PricingFeatureIconStyle} fill="#8C83C3" />
              <Text.BodySM style={{ width: "90%" }}>
                AI Drafts – Smart email responses and meeting scheduling
              </Text.BodySM>
            </div>
            <div className={PricingFeatureStyle}>
              <CheckCircleIcon style={PricingFeatureIconStyle} fill="#8C83C3" />
              <Text.BodySM style={{ width: "90%" }}>
                Meeting Notes – AI-captured takeaways & action items
              </Text.BodySM>
            </div>
          </div>

          <form
            action={`${config.apiUrl}/billing/create-checkout-session`}
            method="POST"
          >
            <input type="hidden" name="userId" value={userState?._id} />
            <input type="hidden" name="quantity" value={quantity} />
            <button
              type="submit"
              onClick={() => setLoading(true)}
              className={PricingButtonStyle}
              disabled={(!isFree && !isTrial) || vipUser}
              style={{
                cursor: loading ? "progress" : "",
                pointerEvents: loading ? "none" : "auto",
              }}
            >
              {(isFree || isTrial) && !vipUser
                ? "Upgrade plan "
                : "Current plan "}
              {loading ? (
                <InfiniteSpinnerIcon
                  fill="dark"
                  style={{ height: "16px", marginLeft: "8px" }}
                />
              ) : null}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
